import type { ArticlePreview } from "@brookbush/types";

import Image from "next/image";
import Link from "next/link";

import ContentDates from "~/components/ContentDates";

interface ArticleCategoryCardProps {
	article: ArticlePreview;
}

const AboutArticlesCard = ({ article }: ArticleCategoryCardProps) => {
	return (
		<div className="flex flex-col gap-4 rounded-2xl transition-all sm:flex-row sm:gap-6">
			<Link
				className="relative z-0 h-48 w-full shrink-0 overflow-hidden rounded-xl border hover:brightness-95 sm:h-40 sm:w-56"
				href={`/articles/${article.slug}`}
			>
				<Image
					src={
						article.thumbnail?.url || "/logos/brookbush-institute-logo-icon.png"
					}
					alt={article.title}
					fill
					className={
						article.thumbnail
							? "object-cover"
							: "object-contain p-4 brightness-95 dark:invert dark:saturate-0"
					}
				/>
			</Link>

			<div className="flex w-full justify-between gap-2">
				<div className="group flex flex-col gap-2">
					<Link href={`/articles/${article.slug}`}>
						<h2 className="line-clamp-2 font-semibold text-xl hover:underline sm:text-2xl">
							{article.title}
						</h2>{" "}
					</Link>

					<p className="line-clamp-3">{article.description}</p>

					{article._createdAt ? (
						<ContentDates
							createdAt={article._createdAt}
							updatedAt={article._updatedAt}
							className="font-normal text-sm"
						/>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default AboutArticlesCard;
